<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row" v-if="role != 'Visitor'">
        <div class="col-xl-4 col-md-6">
          <router-link :to="'/report-slitting'">
            <stats-card class="shadow">
              <div slot="header" class="icon-warning">
                <i class="nc-icon nc-scissors text-muted"></i>
              </div>
              <div slot="content">
                <p class="card-category">Slitting</p>
                <h4 class="card-title"> {{ convertRp(Slt) }} </h4>
              </div>
              <div slot="footer">
              </div>
            </stats-card>
          </router-link>
        </div>

        <div class="col-xl-4 col-md-6">
          <router-link :to="'/produksi-tolling'">
            <stats-card class="shadow">
              <div slot="header" class="icon-warning">
                <i class="nc-icon nc-support-17 text-primary"></i>
              </div>
              <div slot="content">
                <p class="card-category">Tolling Pipa</p>
                <h4 class="card-title"> {{ convertRp(Tll) }} </h4>
              </div>
              <div slot="footer">
              </div>
            </stats-card>
          </router-link>
        </div>

        <div class="col-xl-4 col-md-6">
          <router-link :to="'/report-shearing'">
            <stats-card class="shadow">
              <div slot="header" class="icon-danger">
                <i class="nc-icon nc-preferences-circle-rotate text-danger"></i>
              </div>
              <div slot="content">
                <p class="card-category">Shearing</p>
                <h4 class="card-title"> {{ convertRp(Shr) }} </h4>
              </div>
              <div slot="footer">
              </div>
            </stats-card>
          </router-link>
        </div>
      </div>

      <!-- WEEKLY REPORT -->
      <card class="strpied-tabled-with-hover shadow" body-classes="table-full-width table-responsive">
        <template slot="header">
          <div class="row">
            <div class="col-2">
            </div>
            <div class="col-8 text-center">
              <h5 class="card-title font-weight-bold"><i class="fa fa-bar-chart mr-2"></i>WEEKLY REPORT</h5><br>
              <h5 class="card-title card-subtitle-muted" style="margin-top: -20px; margin-bottom: -30px;">{{ moment().locale('id').format('DD MMMM YYYY').toUpperCase() }}</h5><br>
            </div>
            <div class="col-2">
              <a :href="apiUrl+'print-weekly-report'" target="_BLANK">
                <button type="submit" class="btn btn-sm btn-success btn-fill float-right ml-2">
                  <i class="fa fa-print"></i> Print
                </button>
              </a>
            </div>
          </div>
        </template>
        <!-- <div class="scroll"> -->
        <tabs fill class="report-tabs" @click.native="onReportTabClick">
          <tab-pane key="produksi">
            <template slot="title"><i class="fa fa-industry mr-2"></i>Produksi</template>
          <p class="section-title"><span class="section-dot dot-slate"></span><i class="fa fa-industry"></i> PRODUKSI {{ moment().format('YYYY') }}</p>
          <table border='1' class="mb-4">
            <thead class="thead-slate">
              <slot name="columns">
                <tr>
                  <th style="font-size: 13px; text-align: center;">Deskripsi</th>
                  <th style="font-size: 13px; text-align: center;" v-for="(pm, i) in prodMonths" :key="i">{{ pm.label }}</th>
                </tr>
              </slot>
            </thead>
            <tbody>
              <tr>
                <td style="font-size: 13px; font-weight: bold;">Slitting</td>
                <td style="font-size: 13px; text-align: center;" v-for="(pm, i) in prodMonths" :key="i">{{ convertTon(pm.slitting) }} Ton</td>
              </tr>
              <tr>
                <td style="font-size: 13px; font-weight: bold;">Pipa</td>
                <td style="font-size: 13px; text-align: center;" v-for="(pm, i) in prodMonths" :key="i">{{ convertTon(pm.pipa) }} Ton</td>
              </tr>
              <tr class="row-highlight">
                <td style="font-size: 13px;"></td>
                <td style="font-size: 13px; text-align: center; font-weight: bold;" v-for="(pm, i) in prodMonths" :key="i">{{ convertTon(pm.total) }} Ton</td>
              </tr>
              <tr>
                <td style="font-size: 13px; font-weight: bold;">PO. Slitting</td>
                <td style="font-size: 13px; text-align: center;" v-for="(pm, i) in prodMonths" :key="i">{{ convertTon(pm.po_slitting) }} Ton</td>
              </tr>
              <tr>
                <td style="font-size: 13px; font-weight: bold;">PO. Pipa</td>
                <td style="font-size: 13px; text-align: center;" v-for="(pm, i) in prodMonths" :key="i">{{ convertTon(pm.po_pipa) }} Ton</td>
              </tr>
              <tr class="row-highlight">
                <td style="font-size: 13px;"></td>
                <td style="font-size: 13px; text-align: center; font-weight: bold;" v-for="(pm, i) in prodMonths" :key="i">{{ convertTon(pm.po_total) }} Ton</td>
              </tr>
            </tbody>
          </table>

          <div class="chart-box mb-4">
            <line-chart :chart-data="prodMonthsChartData" :options="prodMonthsChartOptions" :height="220"></line-chart>
          </div>

          <p class="section-title"><span class="section-dot dot-blue"></span><i class="fa fa-calendar-check-o"></i> Produksi Tanggal : {{ moment(start).locale('id').format('DD MMMM YYYY') }} ~ {{ moment(end).locale('id').format('DD MMMM YYYY') }}</p>
          <table border='1' class="mb-4">
            <thead class="thead-blue">
              <slot name="columns">
                <tr>
                  <th style="font-size: 13px; text-align: center;">Deskripsi</th>
                  <th style="font-size: 13px; text-align: center;">Progres Minggu Lalu</th>
                  <th style="font-size: 13px; text-align: center;">Progres Sekarang</th>
                  <th style="font-size: 13px; text-align: center;">Akumulasi</th>
                </tr>
              </slot>
            </thead>
            <tbody>
              <tr>
                <td style="font-size: 13px; font-weight: bold;">Slitting</td>
                <td style="font-size: 13px; text-align: center;">{{ convertTon(weeklySlt, 3) }} Ton</td>
                <td style="font-size: 13px; text-align: center;">{{ currentWeekSlt > 0 ? convertTon(currentWeekSlt, 3) + ' Ton' : '-' }}</td>
                <td style="font-size: 13px; text-align: center;">{{ convertTon(weeklyAklmsiSlt, 3) }} Ton</td>
              </tr>
              <tr>
                <td style="font-size: 13px; font-weight: bold;">Pipa</td>
                <td style="font-size: 13px; text-align: center;">{{ convertTon(weeklyTll, 3) }} Ton</td>
                <td style="font-size: 13px; text-align: center;">{{ currentWeekTll > 0 ? convertTon(currentWeekTll, 3) + ' Ton' : '-' }}</td>
                <td style="font-size: 13px; text-align: center;">{{ convertTon(weeklyAklmsiTll, 3) }} Ton</td>
              </tr>
            </tbody>
          </table>

          </tab-pane>

          <tab-pane key="stok">
            <template slot="title"><i class="fa fa-cube mr-2"></i>Stok Material</template>
          <p class="section-title"><span class="section-dot dot-amber"></span><i class="fa fa-database"></i> Sisa HRC</p>
          <div class="table-responsive">
          <table border='1' class="mb-4">
            <thead class="thead-amber">
              <slot name="columns">
                <tr>
                  <th style="font-size: 12px; text-align: center;" rowspan="2">No</th>
                  <th style="font-size: 12px; text-align: center;" rowspan="2">Deskripsi</th>
                  <th style="font-size: 12px; text-align: center; background-color: #FFD700;" rowspan="2">Progres<br>Minggu Lalu</th>
                  <th style="font-size: 12px; text-align: center; background-color: #FFD700;" colspan="2">Progres Sekarang</th>
                  <th style="font-size: 12px; text-align: center; background-color: #FFD700;" colspan="2">HRC yang Masuk</th>
                  <th style="font-size: 12px; text-align: center; background-color: #FFD700;" colspan="2">HRC Sudah Terpakai</th>
                  <th style="font-size: 12px; text-align: center; background-color: #FFD700;" colspan="2">HRC Return</th>
                  <th style="font-size: 12px; text-align: center; background-color: #FFD700;" colspan="2">Sisa HRC</th>
                </tr>
                <tr>
                  <th style="font-size: 12px; text-align: center; background-color: #FFD700;">Ton</th>
                  <th style="font-size: 12px; text-align: center; background-color: #FFD700;">Coil</th>
                  <th style="font-size: 12px; text-align: center; background-color: #FFD700;">Ton</th>
                  <th style="font-size: 12px; text-align: center; background-color: #FFD700;">Coil</th>
                  <th style="font-size: 12px; text-align: center; background-color: #FFD700;">Ton</th>
                  <th style="font-size: 12px; text-align: center; background-color: #FFD700;">Coil</th>
                  <th style="font-size: 12px; text-align: center; background-color: #FFD700;">Ton</th>
                  <th style="font-size: 12px; text-align: center; background-color: #FFD700;">Coil</th>
                  <th style="font-size: 12px; text-align: center; background-color: #FFD700;">Ton</th>
                  <th style="font-size: 12px; text-align: center; background-color: #FFD700;">Coil</th>
                </tr>
              </slot>
            </thead>
            <tbody>
              <tr v-for="(row, i) in hrcStock" :key="i">
                <td style="font-size: 12px; text-align: center;">{{ i + 1 }}</td>
                <td style="font-size: 12px; font-weight: bold;">{{ row.owner }}</td>
                <td style="font-size: 12px; text-align: center;">{{ convertTon(row.progres_lalu_ton, 3) }} Ton</td>
                <td style="font-size: 12px; text-align: center;">{{ convertTon(row.progres_sekarang_ton, 3) }}</td>
                <td style="font-size: 12px; text-align: center;">{{ row.progres_sekarang_qty }} Coil</td>
                <td style="font-size: 12px; text-align: center;">{{ row.masuk_ton > 0 ? convertTon(row.masuk_ton, 3) : '-' }}</td>
                <td style="font-size: 12px; text-align: center;">{{ row.masuk_qty > 0 ? row.masuk_qty : '-' }}</td>
                <td style="font-size: 12px; text-align: center;">{{ row.terpakai_ton > 0 ? convertTon(row.terpakai_ton, 3) : '-' }}</td>
                <td style="font-size: 12px; text-align: center;">{{ row.terpakai_qty > 0 ? row.terpakai_qty : '-' }}</td>
                <td style="font-size: 12px; text-align: center;">{{ row.return_ton > 0 ? convertTon(row.return_ton, 3) : '-' }}</td>
                <td style="font-size: 12px; text-align: center;">{{ row.return_qty > 0 ? row.return_qty : '-' }}</td>
                <td style="font-size: 12px; text-align: center;">{{ convertTon(row.sisa_ton, 3) }}</td>
                <td style="font-size: 12px; text-align: center;">{{ row.sisa_qty }} Coil</td>
              </tr>
              <tr class="row-highlight">
                <td style="font-size: 12px; font-weight: bold;" colspan="2">Total</td>
                <td style="font-size: 12px; text-align: center; font-weight: bold;">{{ convertTon(sumStock(hrcStock, 'progres_lalu_ton'), 3) }} Ton</td>
                <td style="font-size: 12px; text-align: center; font-weight: bold;">{{ convertTon(sumStock(hrcStock, 'progres_sekarang_ton'), 3) }}</td>
                <td style="font-size: 12px; text-align: center; font-weight: bold;">{{ sumStock(hrcStock, 'progres_sekarang_qty') }}</td>
                <td style="font-size: 12px; text-align: center; font-weight: bold;">{{ convertTon(sumStock(hrcStock, 'masuk_ton'), 3) }}</td>
                <td style="font-size: 12px; text-align: center; font-weight: bold;">{{ sumStock(hrcStock, 'masuk_qty') }}</td>
                <td style="font-size: 12px; text-align: center; font-weight: bold;">{{ convertTon(sumStock(hrcStock, 'terpakai_ton'), 3) }}</td>
                <td style="font-size: 12px; text-align: center; font-weight: bold;">{{ sumStock(hrcStock, 'terpakai_qty') }}</td>
                <td style="font-size: 12px; text-align: center; font-weight: bold;">{{ convertTon(sumStock(hrcStock, 'return_ton'), 3) }}</td>
                <td style="font-size: 12px; text-align: center; font-weight: bold;">{{ sumStock(hrcStock, 'return_qty') }}</td>
                <td style="font-size: 12px; text-align: center; font-weight: bold;">{{ convertTon(sumStock(hrcStock, 'sisa_ton'), 3) }}</td>
                <td style="font-size: 12px; text-align: center; font-weight: bold;">{{ sumStock(hrcStock, 'sisa_qty') }} Coil</td>
              </tr>
            </tbody>
          </table>
          </div>

          <div class="row mb-4">
            <div class="col-md-6 offset-md-3">
              <div class="chart-box" style="height: 260px;">
                <p class="chart-box-title">Komposisi Sisa HRC per Owner</p>
                <doughnut-chart :key="hrcChartKey" :chart-data="hrcDoughnutData" :options="hrcDoughnutOptions" :height="200"></doughnut-chart>
              </div>
            </div>
          </div>

          <p class="section-title"><span class="section-dot dot-rose"></span><i class="fa fa-database"></i> Sisa Slit Coil</p>
          <div class="table-responsive">
          <table border='1' class="mb-4">
            <thead class="thead-rose">
              <slot name="columns">
                <tr>
                  <th style="font-size: 12px; text-align: center;" rowspan="2">No</th>
                  <th style="font-size: 12px; text-align: center;" rowspan="2">Deskripsi</th>
                  <th style="font-size: 12px; text-align: center; background-color: #F08080;" rowspan="2">Progres<br>Minggu Lalu</th>
                  <th style="font-size: 12px; text-align: center; background-color: #F08080;" colspan="2">Progres Sekarang</th>
                  <th style="font-size: 12px; text-align: center; background-color: #F08080;" colspan="2">Slit Coil yang Masuk</th>
                  <th style="font-size: 12px; text-align: center; background-color: #F08080;" colspan="2">Slit Coil Sudah Terpakai</th>
                  <th style="font-size: 12px; text-align: center; background-color: #F08080;" colspan="2">Slit Coil Return</th>
                  <th style="font-size: 12px; text-align: center; background-color: #F08080;" colspan="2">Sisa Slit Coil</th>
                </tr>
                <tr>
                  <th style="font-size: 12px; text-align: center; background-color: #F08080;">Ton</th>
                  <th style="font-size: 12px; text-align: center; background-color: #F08080;">Coil</th>
                  <th style="font-size: 12px; text-align: center; background-color: #F08080;">Ton</th>
                  <th style="font-size: 12px; text-align: center; background-color: #F08080;">Coil</th>
                  <th style="font-size: 12px; text-align: center; background-color: #F08080;">Ton</th>
                  <th style="font-size: 12px; text-align: center; background-color: #F08080;">Coil</th>
                  <th style="font-size: 12px; text-align: center; background-color: #F08080;">Ton</th>
                  <th style="font-size: 12px; text-align: center; background-color: #F08080;">Coil</th>
                  <th style="font-size: 12px; text-align: center; background-color: #F08080;">Ton</th>
                  <th style="font-size: 12px; text-align: center; background-color: #F08080;">Coil</th>
                </tr>
              </slot>
            </thead>
            <tbody>
              <tr v-for="(row, i) in scStock" :key="i">
                <td style="font-size: 12px; text-align: center;">{{ i + 1 }}</td>
                <td style="font-size: 12px; font-weight: bold;">{{ row.owner }}</td>
                <td style="font-size: 12px; text-align: center;">{{ convertTon(row.progres_lalu_ton, 3) }} Ton</td>
                <td style="font-size: 12px; text-align: center;">{{ convertTon(row.progres_sekarang_ton, 3) }}</td>
                <td style="font-size: 12px; text-align: center;">{{ row.progres_sekarang_qty }} Coil</td>
                <td style="font-size: 12px; text-align: center;">{{ row.masuk_ton > 0 ? convertTon(row.masuk_ton, 3) : '-' }}</td>
                <td style="font-size: 12px; text-align: center;">{{ row.masuk_qty > 0 ? row.masuk_qty : '-' }}</td>
                <td style="font-size: 12px; text-align: center;">{{ row.terpakai_ton > 0 ? convertTon(row.terpakai_ton, 3) : '-' }}</td>
                <td style="font-size: 12px; text-align: center;">{{ row.terpakai_qty > 0 ? row.terpakai_qty : '-' }}</td>
                <td style="font-size: 12px; text-align: center;">{{ row.return_ton > 0 ? convertTon(row.return_ton, 3) : '-' }}</td>
                <td style="font-size: 12px; text-align: center;">{{ row.return_qty > 0 ? row.return_qty : '-' }}</td>
                <td style="font-size: 12px; text-align: center;">{{ convertTon(row.sisa_ton, 3) }}</td>
                <td style="font-size: 12px; text-align: center;">{{ row.sisa_qty }} Coil</td>
              </tr>
              <tr class="row-highlight">
                <td style="font-size: 12px; font-weight: bold;" colspan="2">Total</td>
                <td style="font-size: 12px; text-align: center; font-weight: bold;">{{ convertTon(sumStock(scStock, 'progres_lalu_ton'), 3) }} Ton</td>
                <td style="font-size: 12px; text-align: center; font-weight: bold;">{{ convertTon(sumStock(scStock, 'progres_sekarang_ton'), 3) }}</td>
                <td style="font-size: 12px; text-align: center; font-weight: bold;">{{ sumStock(scStock, 'progres_sekarang_qty') }}</td>
                <td style="font-size: 12px; text-align: center; font-weight: bold;">{{ convertTon(sumStock(scStock, 'masuk_ton'), 3) }}</td>
                <td style="font-size: 12px; text-align: center; font-weight: bold;">{{ sumStock(scStock, 'masuk_qty') }}</td>
                <td style="font-size: 12px; text-align: center; font-weight: bold;">{{ convertTon(sumStock(scStock, 'terpakai_ton'), 3) }}</td>
                <td style="font-size: 12px; text-align: center; font-weight: bold;">{{ sumStock(scStock, 'terpakai_qty') }}</td>
                <td style="font-size: 12px; text-align: center; font-weight: bold;">{{ convertTon(sumStock(scStock, 'return_ton'), 3) }}</td>
                <td style="font-size: 12px; text-align: center; font-weight: bold;">{{ sumStock(scStock, 'return_qty') }}</td>
                <td style="font-size: 12px; text-align: center; font-weight: bold;">{{ convertTon(sumStock(scStock, 'sisa_ton'), 3) }}</td>
                <td style="font-size: 12px; text-align: center; font-weight: bold;">{{ sumStock(scStock, 'sisa_qty') }} Coil</td>
              </tr>
            </tbody>
          </table>
          </div>

          </tab-pane>

          <tab-pane key="sipo-po">
            <template slot="title"><i class="fa fa-shopping-cart mr-2"></i>SIPO &amp; PO</template>
          <p class="section-title"><span class="section-dot dot-violet"></span><i class="fa fa-cubes"></i> SIPO</p>
          <div class="table-responsive">
          <table border='1' class="mb-4">
            <thead class="thead-violet">
              <slot name="columns">
                <tr>
                  <th style="font-size: 13px; text-align: center;">No</th>
                  <th style="font-size: 13px; text-align: center;">Deskripsi</th>
                  <th style="font-size: 13px; text-align: center;">Progres Minggu Lalu</th>
                  <th style="font-size: 13px; text-align: center;">Progres Sekarang</th>
                </tr>
              </slot>
            </thead>
            <tbody>
              <tr v-for="(row, i) in sipoStock" :key="i">
                <td style="font-size: 13px; text-align: center;">{{ i + 1 }}</td>
                <td style="font-size: 13px; font-weight: bold;">{{ row.owner }}</td>
                <td style="font-size: 13px; text-align: center;">{{ row.progres_lalu_ton > 0 ? convertTon(row.progres_lalu_ton, 3) + ' Ton' : '- Ton' }}</td>
                <td style="font-size: 13px; text-align: center;">{{ row.progres_sekarang_ton > 0 ? convertTon(row.progres_sekarang_ton, 3) + ' Ton' : '- Ton' }}</td>
              </tr>
              <tr class="row-highlight">
                <td style="font-size: 13px; text-align: center; font-weight: bold;" colspan="2">Total</td>
                <td style="font-size: 13px; text-align: center; font-weight: bold;">{{ convertTon(sumStock(sipoStock, 'progres_lalu_ton'), 3) }} Ton</td>
                <td style="font-size: 13px; text-align: center; font-weight: bold;">{{ convertTon(sumStock(sipoStock, 'progres_sekarang_ton'), 3) }} Ton</td>
              </tr>
            </tbody>
          </table>
          </div>

          <p class="section-title"><span class="section-dot dot-green"></span><i class="fa fa-shopping-cart"></i> Purchase Order Slitting</p>
          <div class="table-responsive">
          <table border='1' class="mb-4">
            <thead class="thead-green">
              <slot name="columns">
                <tr>
                  <th style="font-size: 13px; text-align: center;">No</th>
                  <th style="font-size: 13px; text-align: center;">Deskripsi</th>
                  <th style="font-size: 13px; text-align: center;">Progres Minggu Lalu</th>
                  <th style="font-size: 13px; text-align: center;">Progres Sekarang</th>
                  <th style="font-size: 13px; text-align: center;">Akumulasi</th>
                </tr>
              </slot>
            </thead>
            <tbody>
              <tr v-for="(row, i) in poSlitting" :key="i">
                <td style="font-size: 13px; text-align: center;">{{ i + 1 }}</td>
                <td style="font-size: 13px; font-weight: bold;">{{ row.owner }}</td>
                <td style="font-size: 13px; text-align: center;">{{ row.progres_lalu_ton > 0 ? convertTon(row.progres_lalu_ton, 3) + ' Ton' : '- Ton' }}</td>
                <td style="font-size: 13px; text-align: center;">{{ row.progres_sekarang_ton > 0 ? convertTon(row.progres_sekarang_ton, 3) + ' Ton' : '- Ton' }}</td>
                <td style="font-size: 13px; text-align: center;">{{ row.akumulasi_ton > 0 ? convertTon(row.akumulasi_ton, 3) + ' Ton' : '- Ton' }}</td>
              </tr>
              <tr class="row-highlight">
                <td style="font-size: 13px; text-align: center; font-weight: bold;" colspan="2">Total</td>
                <td style="font-size: 13px; text-align: center; font-weight: bold;">{{ convertTon(sumStock(poSlitting, 'progres_lalu_ton'), 3) }} Ton</td>
                <td style="font-size: 13px; text-align: center; font-weight: bold;">{{ convertTon(sumStock(poSlitting, 'progres_sekarang_ton'), 3) }} Ton</td>
                <td style="font-size: 13px; text-align: center; font-weight: bold;">{{ convertTon(sumStock(poSlitting, 'akumulasi_ton'), 3) }} Ton</td>
              </tr>
            </tbody>
          </table>
          </div>

          <p class="section-title"><span class="section-dot dot-sky"></span><i class="fa fa-shopping-cart"></i> Purchase Order Tolling</p>
          <div class="table-responsive">
          <table border='1' class="mb-4">
            <thead class="thead-sky">
              <slot name="columns">
                <tr>
                  <th style="font-size: 13px; text-align: center;">No</th>
                  <th style="font-size: 13px; text-align: center;">Deskripsi</th>
                  <th style="font-size: 13px; text-align: center;">Progres Minggu Lalu</th>
                  <th style="font-size: 13px; text-align: center;">Progres Sekarang</th>
                  <th style="font-size: 13px; text-align: center;">Akumulasi</th>
                </tr>
              </slot>
            </thead>
            <tbody>
              <tr v-for="(row, i) in poTolling" :key="i">
                <td style="font-size: 13px; text-align: center;">{{ i + 1 }}</td>
                <td style="font-size: 13px; font-weight: bold;">{{ row.owner }}</td>
                <td style="font-size: 13px; text-align: center;">{{ row.progres_lalu_ton > 0 ? convertTon(row.progres_lalu_ton, 3) + ' Ton' : '- Ton' }}</td>
                <td style="font-size: 13px; text-align: center;">{{ row.progres_sekarang_ton > 0 ? convertTon(row.progres_sekarang_ton, 3) + ' Ton' : '- Ton' }}</td>
                <td style="font-size: 13px; text-align: center;">{{ row.akumulasi_ton > 0 ? convertTon(row.akumulasi_ton, 3) + ' Ton' : '- Ton' }}</td>
              </tr>
              <tr class="row-highlight">
                <td style="font-size: 13px; text-align: center; font-weight: bold;" colspan="2">Total</td>
                <td style="font-size: 13px; text-align: center; font-weight: bold;">{{ convertTon(sumStock(poTolling, 'progres_lalu_ton'), 3) }} Ton</td>
                <td style="font-size: 13px; text-align: center; font-weight: bold;">{{ convertTon(sumStock(poTolling, 'progres_sekarang_ton'), 3) }} Ton</td>
                <td style="font-size: 13px; text-align: center; font-weight: bold;">{{ convertTon(sumStock(poTolling, 'akumulasi_ton'), 3) }} Ton</td>
              </tr>
            </tbody>
          </table>
          </div>

          <div class="chart-box mb-2" style="height: 280px;">
            <p class="chart-box-title">Akumulasi PO Slitting vs PO Tolling per Owner</p>
            <horizontal-bar-chart :key="poChartKey" :chart-data="poChartData" :options="poChartOptions" :height="220"></horizontal-bar-chart>
          </div>
          </tab-pane>
        </tabs>
        <!-- </div> -->
      </card>

      <!-- PER MOUNTH -->
      <card class="strpied-tabled-with-hover shadow" body-classes="table-full-width table-responsive">
        <template slot="header">
          <div class="row">
            <div class="col-2">
              <button type="button" class="btn-collapse-toggle" @click="showRkpMonthly = !showRkpMonthly">
                <i :class="['fa', showRkpMonthly ? 'fa-chevron-up' : 'fa-chevron-down']"></i> {{ showRkpMonthly ? 'Sembunyikan' : 'Tampilkan' }}
              </button>
            </div>
            <div class="col-8 text-center">
              <h5 class="card-title font-weight-bold"><i class="fa fa-calendar mr-2"></i>RKP PRODUKSI - {{new Date().getFullYear()}}</h5><br>
              <h5 class="card-title card-subtitle-muted" style="margin-top: -20px; margin-bottom: -30px;">PT. BUANA CENTRA KARYA</h5><br>
            </div>
            <div class="col-2">
              <select class="form-select form-control" aria-label="Default select example" v-model="year" @click="getRkpProduksiMonth(), getRkpProduksiDaily(month)">
                <option value="2026">2026</option>
                <option value="2025">2025</option>
                <option value="2024">2024</option>
                <option value="2023">2023</option>
                <option value="2022">2022</option>
              </select>
            </div>
          </div>
        </template>
        <!-- <div class="scroll"> -->
        <div v-show="showRkpMonthly">
          <table border='1'>
            <thead>
              <slot name="columns">
                <tr>
                  <th style="font-size: 13px; text-align: center; background-color: #67728c; color: #fff;">PERIODE</th>
                  <th style="font-size: 13px; text-align: center; background-color: #4c86d1; color: #fff;">SLITTING</th>
                  <th style="font-size: 13px; text-align: center; background-color: #5cb583; color: #fff;">TOLLING PIPA</th>
                  <th style="font-size: 13px; text-align: center; background-color: #dba434; color: #fff;">SHEARING</th>
                </tr>
              </slot>
            </thead>
            <tbody>
              <tr>
                <td style="font-size: 13px; cursor: pointer; color: blue;" @click="getRkpProduksiDaily(1), get(1), dailyReportModal.show = true">JANUARI</td>
                <td style="font-size: 13px; text-align: center; background-color: #F0E68C;">{{ convertRp(rkpSlt.Jan) }}</td>
                <td style="font-size: 13px; text-align: center; background-color: #00FA9A;">{{ convertRp(rkpTll.Jan) }}</td>
                <td style="font-size: 13px; text-align: center; background-color: #FFF5EE;">{{ convertRp(rkpShr.Jan) }}</td>
              </tr>
              <tr>
                <td style="font-size: 13px; cursor: pointer; color: blue;" @click="getRkpProduksiDaily(2), get(2), dailyReportModal.show = true">FEBRUARI</td>
                <td style="font-size: 13px; text-align: center; background-color: #F0E68C;">{{ convertRp(rkpSlt.Feb) }}</td>
                <td style="font-size: 13px; text-align: center; background-color: #00FA9A;">{{ convertRp(rkpTll.Feb) }}</td>
                <td style="font-size: 13px; text-align: center; background-color: #FFF5EE;">{{ convertRp(rkpShr.Feb) }}</td>
              </tr>
              <tr>
                <td style="font-size: 13px; cursor: pointer; color: blue;" @click="getRkpProduksiDaily(3), get(3), dailyReportModal.show = true">MARET</td>
                <td style="font-size: 13px; text-align: center; background-color: #F0E68C;">{{ convertRp(rkpSlt.Mar) }}</td>
                <td style="font-size: 13px; text-align: center; background-color: #00FA9A;">{{ convertRp(rkpTll.Mar) }}</td>
                <td style="font-size: 13px; text-align: center; background-color: #FFF5EE;">{{ convertRp(rkpShr.Mar) }}</td>
              </tr>
              <tr>
                <td style="font-size: 13px; cursor: pointer; color: blue;" @click="getRkpProduksiDaily(4), get(4), dailyReportModal.show = true">APRIL</td>
                <td style="font-size: 13px; text-align: center; background-color: #F0E68C;">{{ convertRp(rkpSlt.Apr) }}</td>
                <td style="font-size: 13px; text-align: center; background-color: #00FA9A;">{{ convertRp(rkpTll.Apr) }}</td>
                <td style="font-size: 13px; text-align: center; background-color: #FFF5EE;">{{ convertRp(rkpShr.Apr) }}</td>
              </tr>
              <tr>
                <td style="font-size: 13px; cursor: pointer; color: blue;" @click="getRkpProduksiDaily(5), get(5), dailyReportModal.show = true">MEI</td>
                <td style="font-size: 13px; text-align: center; background-color: #F0E68C;">{{ convertRp(rkpSlt.Mei) }}</td>
                <td style="font-size: 13px; text-align: center; background-color: #00FA9A;">{{ convertRp(rkpTll.Mei) }}</td>
                <td style="font-size: 13px; text-align: center; background-color: #FFF5EE;">{{ convertRp(rkpShr.Mei) }}</td>
              </tr>
              <tr>
                <td style="font-size: 13px; cursor: pointer; color: blue;" @click="getRkpProduksiDaily(6), get(6), dailyReportModal.show = true">JUNI</td>
                <td style="font-size: 13px; text-align: center; background-color: #F0E68C;">{{ convertRp(rkpSlt.Jun) }}</td>
                <td style="font-size: 13px; text-align: center; background-color: #00FA9A;">{{ convertRp(rkpTll.Jun) }}</td>
                <td style="font-size: 13px; text-align: center; background-color: #FFF5EE;">{{ convertRp(rkpShr.Jun) }}</td>
              </tr>
              <tr>
                <td style="font-size: 13px; cursor: pointer; color: blue;" @click="getRkpProduksiDaily(7), get(7), dailyReportModal.show = true">JULI</td>
                <td style="font-size: 13px; text-align: center; background-color: #F0E68C;">{{ convertRp(rkpSlt.Jul) }}</td>
                <td style="font-size: 13px; text-align: center; background-color: #00FA9A;">{{ convertRp(rkpTll.Jul) }}</td>
                <td style="font-size: 13px; text-align: center; background-color: #FFF5EE;">{{ convertRp(rkpShr.Jul) }}</td>
              </tr>
              <tr>
                <td style="font-size: 13px; cursor: pointer; color: blue;" @click="getRkpProduksiDaily(8), get(8), dailyReportModal.show = true">AGUSTUS</td>
                <td style="font-size: 13px; text-align: center; background-color: #F0E68C;">{{ convertRp(rkpSlt.Aug) }}</td>
                <td style="font-size: 13px; text-align: center; background-color: #00FA9A;">{{ convertRp(rkpTll.Aug) }}</td>
                <td style="font-size: 13px; text-align: center; background-color: #FFF5EE;">{{ convertRp(rkpShr.Aug) }}</td>
              </tr>
              <tr>
                <td style="font-size: 13px; cursor: pointer; color: blue;" @click="getRkpProduksiDaily(9), get(9), dailyReportModal.show = true">SEPTEMBER</td>
                <td style="font-size: 13px; text-align: center; background-color: #F0E68C;">{{ convertRp(rkpSlt.Sep) }}</td>
                <td style="font-size: 13px; text-align: center; background-color: #00FA9A;">{{ convertRp(rkpTll.Sep) }}</td>
                <td style="font-size: 13px; text-align: center; background-color: #FFF5EE;">{{ convertRp(rkpShr.Sep) }}</td>
              </tr>
              <tr>
                <td style="font-size: 13px; cursor: pointer; color: blue;" @click="getRkpProduksiDaily(10), get(10), dailyReportModal.show = true">OKTOBER</td>
                <td style="font-size: 13px; text-align: center; background-color: #F0E68C;">{{ convertRp(rkpSlt.Oct) }}</td>
                <td style="font-size: 13px; text-align: center; background-color: #00FA9A;">{{ convertRp(rkpTll.Oct) }}</td>
                <td style="font-size: 13px; text-align: center; background-color: #FFF5EE;">{{ convertRp(rkpShr.Oct) }}</td>
              </tr>
              <tr>
                <td style="font-size: 13px; cursor: pointer; color: blue;" @click="getRkpProduksiDaily(11), get(11), dailyReportModal.show = true">NOVEMBER</td>
                <td style="font-size: 13px; text-align: center; background-color: #F0E68C;">{{ convertRp(rkpSlt.Nov) }}</td>
                <td style="font-size: 13px; text-align: center; background-color: #00FA9A;">{{ convertRp(rkpTll.Nov) }}</td>
                <td style="font-size: 13px; text-align: center; background-color: #FFF5EE;">{{ convertRp(rkpShr.Nov) }}</td>
              </tr>
              <tr>
                <td style="font-size: 13px; cursor: pointer; color: blue;" @click="getRkpProduksiDaily(12), get(12), dailyReportModal.show = true">DESEMBER</td>
                <td style="font-size: 13px; text-align: center; background-color: #F0E68C;">{{ convertRp(rkpSlt.Des) }}</td>
                <td style="font-size: 13px; text-align: center; background-color: #00FA9A;">{{ convertRp(rkpTll.Des) }}</td>
                <td style="font-size: 13px; text-align: center; background-color: #FFF5EE;">{{ convertRp(rkpShr.Des) }}</td>
              </tr>
              <tr class="row-highlight">
                <td style="font-size: 13px; text-align: center; font-weight: bold;">TOTAL</td>
                <td style="font-size: 13px; text-align: center; font-weight: bold;">{{ convertRp(totalWeightProdSlt) }}</td>
                <td style="font-size: 13px; text-align: center; font-weight: bold;">{{ convertRp(totalWeightProdTll) }}</td>
                <td style="font-size: 13px; text-align: center; font-weight: bold;">{{ convertRp(totalWeightProdShr) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- </div> -->
      </card>

      <!-- DAILY (modal, opened by clicking a month in RKP PRODUKSI table) -->
      <modal-lg :show.sync="dailyReportModal.show" modal-classes="modal-xl">
        <template slot="header">
          <div class="row w-100">
            <div class="col-9 text-left">
              <h5 class="card-title font-weight-bold mb-0"><i class="fa fa-clock-o mr-2"></i>DAILY PRODUCTION REPORT</h5>
              <h5 class="card-title card-subtitle-muted mb-0">{{ moment().set({'month': Number(month) - 1}).locale('id').format('MMMM').toUpperCase() }} {{ year }}</h5>
            </div>
            <div class="col-3 text-right">
              <a :href="apiUrl+'print-daily-production-report?month='+month+'&year='+year+''" target="_BLANK">
                <button type="submit" class="btn btn-sm btn-success btn-fill">
                  <i class="fa fa-print"></i> Print
                </button>
              </a>
            </div>
          </div>
        </template>
          <table border='1'>
            <thead>
              <slot name="columns">
                <tr>
                  <th style="font-size: 13px; text-align: center; background-color: #67728c; color: #fff;" width="4">DAY</th>
                  <th style="font-size: 13px; text-align: center; background-color: #67728c; color: #fff;" width="4">DATE</th>
                  <th style="font-size: 13px; text-align: center; background-color: #4c86d1; color: #fff;">SLITTING</th>
                  <th style="font-size: 13px; text-align: center; background-color: #5cb583; color: #fff;">TOLLING PIPA</th>
                  <th style="font-size: 13px; text-align: center; background-color: #dba434; color: #fff;">SHEARING</th>
                </tr>
              </slot>
            </thead>
            <tbody>
              <tr v-for="(row, i) in table.data" :key="i">
                <td style="font-size: 13px; text-align: center;" :style="(moment(year+'-'+month+'-'+i).locale('id').format('ddd') == 'Sab' || moment(year+'-'+month+'-'+i).locale('id').format('ddd') == 'Min') ? 'background-color: red; color: white;' : ''">{{ moment(year+'-'+month+'-'+i).locale('id').format('ddd') }}</td>
                <td style="font-size: 13px; text-align: center;" :style="(moment(year+'-'+month+'-'+i).locale('id').format('ddd') == 'Sab' || moment(year+'-'+month+'-'+i).locale('id').format('ddd') == 'Min') ? 'background-color: red; color: white;' : ''">{{ i }}</td>
                <td style="font-size: 13px; text-align: center;" :style="(moment(year+'-'+month+'-'+i).locale('id').format('ddd') == 'Sab' || moment(year+'-'+month+'-'+i).locale('id').format('ddd') == 'Min') ? 'background-color: red; color: white;' : 'background-color: #DCDCDC;'">{{ convertRp(table.data[i]) }}</td>
                <td style="font-size: 13px; text-align: center;" :style="(moment(year+'-'+month+'-'+i).locale('id').format('ddd') == 'Sab' || moment(year+'-'+month+'-'+i).locale('id').format('ddd') == 'Min') ? 'background-color: red; color: white;' : 'background-color: #F0FFF0;'">{{ convertRp(table.dataTll[i]) }}</td>
                <td style="font-size: 13px; text-align: center;" :style="(moment(year+'-'+month+'-'+i).locale('id').format('ddd') == 'Sab' || moment(year+'-'+month+'-'+i).locale('id').format('ddd') == 'Min') ? 'background-color: red; color: white;' : 'background-color: #FFFACD;'">{{ convertRp(table.dataShr[i]) }}</td>
              </tr>
              <tr class="row-highlight">
                <td colspan="2" style="font-size: 13px; text-align: center; font-weight: bold;">TOTAL</td>
                <td style="font-size: 13px; text-align: center; font-weight: bold;">{{ convertRp(weightSltDaily) }}</td>
                <td style="font-size: 13px; text-align: center; font-weight: bold;">{{ convertRp(weightTllDaily) }}</td>
                <td style="font-size: 13px; text-align: center; font-weight: bold;">{{ convertRp(weightShrDaily) }}</td>
              </tr>
            </tbody>
          </table>
      </modal-lg>

      <!-- CHART INVOICE -->
      <card class="strpied-tabled-with-hover shadow" body-classes="table-full-width table-responsive">
        <template slot="header">
          <div class="row">
            <div class="col-2">
              <button type="button" class="btn-collapse-toggle" @click="toggleDiagram">
                <i :class="['fa', showDiagram ? 'fa-chevron-up' : 'fa-chevron-down']"></i> {{ showDiagram ? 'Sembunyikan' : 'Tampilkan' }}
              </button>
            </div>
            <div class="col-8 text-center">
              <h5 class="card-title font-weight-bold"><i class="fa fa-line-chart mr-2"></i>DIAGRAM WEIGHT PRODUKSI</h5><br>
              <h5 class="card-title card-subtitle-muted" style="margin-top: -20px; margin-bottom: -30px;">{{ moment().set({'month': Number(month) - 1}).locale('id').format('MMMM').toUpperCase() }} {{ year }}</h5><br>
            </div>
            <div class="col-2">
              <a :href="apiUrl+'print-rkp-produksi?month='+month+'&year='+year+''" target="_BLANK">
                <button type="submit" class="btn btn-sm btn-success btn-fill float-right ml-2">
                  <i class="fa fa-print "></i> Print
                </button>
              </a>
            </div>
          </div>
        </template>
        <div class="container" v-show="showDiagram">
          <line-chart :key="diagramChartKey" :chart-data="datacollection" :width="300" :height="120"></line-chart>
        </div>
      </card>

      <!-- TOTAL AKUMULASI PER CLIENT -->
      <card class="strpied-tabled-with-hover shadow" body-classes="table-full-width table-responsive">
        <template slot="header">
          <div class="row">
            <div class="col-2">
              <button type="button" class="btn-collapse-toggle" @click="showAkumulasi = !showAkumulasi">
                <i :class="['fa', showAkumulasi ? 'fa-chevron-up' : 'fa-chevron-down']"></i> {{ showAkumulasi ? 'Sembunyikan' : 'Tampilkan' }}
              </button>
            </div>
            <div class="col-8 text-center">
              <h5 class="card-title font-weight-bold"><i class="fa fa-pie-chart mr-2"></i>RKP WEIGHT PRODUKSI</h5><br>
              <h5 class="card-title card-subtitle-muted" style="margin-top: -20px; margin-bottom: -30px;">PT. BUANA CENTRA KARYA</h5><br>
              <h5 class="card-title card-subtitle-muted" style="margin-top: 10px; margin-bottom: -30px;">{{ moment().set({'month': Number(month) - 1}).locale('id').format('MMMM').toUpperCase() }} {{ year }}</h5><br>
            </div>
            <div class="col-2">
            </div>
          </div>
        </template>
        <div v-show="showAkumulasi">
          <p class="section-title"><span class="section-dot dot-blue"></span><i class="fa fa-scissors"></i> PRODUKSI SLITTING</p>
          <table border='1'>
            <thead class="thead-blue">
              <slot name="columns">
                <tr>
                  <th style="font-size: 13px; text-align: center;">NO</th>
                  <th style="font-size: 13px; text-align: center;">CUSTOMER</th>
                  <th style="font-size: 13px; text-align: center;">WEIGHT</th>
                </tr>
              </slot>
            </thead>
            <tbody>
              <tr v-for="(row, i) in tableAkumulasiClientSlitting.data" :key="i">
                <td style="font-size: 13px; text-align: center;">{{ i + 1 }}</td>
                <td style="font-size: 13px;">{{ row.owner }}</td>
                <td style="font-size: 13px; text-align: center;"> {{ convertRp(+row.weight_slitting + +row.scrap_slitting) }} </td>
              </tr>
              <tr class="row-highlight">
                <td style="font-size: 13px; text-align: center; font-weight: bold;" colspan="2">TOTAL</td>
                <td style="font-size: 13px; text-align: center; font-weight: bold;"> {{ convertRp(totalAkumulasiSlittingAll) }}</td>
              </tr>
            </tbody>
          </table>

          <p class="section-title"><span class="section-dot dot-sky"></span><i class="fa fa-industry"></i> PRODUKSI TOLLING</p>
          <table border='1'>
            <thead class="thead-sky">
              <slot name="columns">
                <tr>
                  <th style="font-size: 13px; text-align: center;">NO</th>
                  <th style="font-size: 13px; text-align: center;">CUSTOMER</th>
                  <th style="font-size: 13px; text-align: center;">WEIGHT</th>
                </tr>
              </slot>
            </thead>
            <tbody>
              <tr v-for="(row, i) in tableAkumulasiClientTolling.data" :key="i">
                <td style="font-size: 13px; text-align: center;">{{ i + 1 }}</td>
                <td style="font-size: 13px;">{{ row.client_name }}</td>
                <td style="font-size: 13px; text-align: center;"> {{ convertRp(row.weight_tolling) }} </td>
              </tr>
              <tr class="row-highlight">
                <td style="font-size: 13px; text-align: center; font-weight: bold;" colspan="2">TOTAL</td>
                <td style="font-size: 13px; text-align: center; font-weight: bold;"> {{ convertRp(totalAkumulasiTollingAll) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </card>

      </div>
    </div>
  </div>
</template>
<script>
  import config from '@/configs/config';
  import Api from '@/helpers/api';
  import produksi from '@/services/produksi.service';
  import ChartCard from '@/components/Cards/ChartCard.vue'
  import StatsCard from '@/components/Cards/StatsCard.vue'
  import Tabs from '@/components/Tabs/Tabs.vue'
  import TabPane from '@/components/Tabs/TabPane.vue'
  import ModalLg from '@/components/ModalLg.vue'
  var moment = require('moment');
  import LineChart from '../LineChart.js'
  import DoughnutChart from '../DoughnutChart.js'
  import HorizontalBarChart from '../HorizontalBarChart.js'

  export default {
    components: {
      ChartCard,
      StatsCard,
      DoughnutChart,
      HorizontalBarChart,
      LineChart,
      Tabs,
      TabPane,
      ModalLg,
    },
    data () {
      return {    
        moment:moment,
        apiUrl :config.apiUrl,
        showRkpMonthly: false,
        showDiagram: false,
        showAkumulasi: false,
        diagramChartKey: 0,
        tokenApi : '',
        role : '',
        Slt : '',
        Tll : '',
        Shr : '',
        tableAkumulasiClientSlitting: {
          data: []
        },
        tableAkumulasiClientTolling: {
          data: []
        },
        totalAkumulasiSlittingAll: '',
        totalAkumulasiTollingAll: '',
        rkpSlt: {},
        rkpTll: {},
        rkpShr: {},

        totalWeightSltDhj: '',
        totalWeightSltKpi: '',
        totalWeightTllDhj: '',
        totalWeightTllKpi: '',
        totalWeightShrAll: '',

        totalWeightProdSlt: '',
        totalWeightProdTll: '',
        totalWeightProdShr: '',
        table: {
          data: []
        },
        table: {
          dataTll: []
        },
        table: {
          dataShr: []
        },
        weightSltDaily: '',
        weightTllDaily: '',
        weightShrDaily: '',
        month: '',
        dailyReportModal: {
          show: false
        },

        hrcStock: [],
        scStock: [],
        sipoStock: [],
        poSlitting: [],
        poTolling: [],
        start: '',
        end: '',
        weeklySlt: '',
        weeklyAklmsiSlt: '',
        weeklyTll: '',
        weeklyAklmsiTll: '',
        currentWeekSlt: '',
        currentWeekTll: '',
        prodMonths: [],
        prodMonthsChartData: null,
        prodMonthsChartOptions: {
          responsive: true,
          maintainAspectRatio: false,
          legend: { position: 'bottom', labels: { boxWidth: 12, fontSize: 12 } },
          scales: {
            yAxes: [{ ticks: { beginAtZero: true, callback: function(v){ return v + ' Ton' } } }]
          },
          tooltips: {
            callbacks: { label: function(item, data){ return data.datasets[item.datasetIndex].label + ': ' + item.yLabel.toLocaleString('id-ID') + ' Ton' } }
          }
        },

        hrcChartKey: 0,
        poChartKey: 0,

        hrcDoughnutData: null,
        hrcDoughnutOptions: {
          responsive: true,
          maintainAspectRatio: false,
          legend: { position: 'right', labels: { boxWidth: 12, fontSize: 11 } },
          tooltips: {
            callbacks: { label: function(item, data){
              var label = data.labels[item.index]
              var value = data.datasets[0].data[item.index]
              return label + ': ' + Number(value).toLocaleString('id-ID', {minimumFractionDigits: 3, maximumFractionDigits: 3}) + ' Ton'
            } }
          }
        },

        poChartData: null,
        poChartOptions: {
          responsive: true,
          maintainAspectRatio: false,
          legend: { position: 'bottom', labels: { boxWidth: 12, fontSize: 12 } },
          scales: {
            xAxes: [{ ticks: { beginAtZero: true, callback: function(v){ return v + ' Ton' } } }]
          },
          tooltips: {
            callbacks: { label: function(item, data){ return data.datasets[item.datasetIndex].label + ': ' + item.xLabel.toLocaleString('id-ID') + ' Ton' } }
          }
        },

        totalWeightSltDhj: '',
        totalWeightSltKpi: '',
        totalWeightTllDhj: '',
        totalWeightTllKpi: '',

        datacollection: null,
        month: '',
        year: '',
      }
    },
    mounted(){
      this.tokenApi = 'Bearer '+localStorage.getItem('token');
      this.role = localStorage.getItem('role');
      this.month = moment().format('MM')
      this.year  = new Date().getFullYear()
      this.get();
      this.getRkpProduksiMonth();
      this.getWeeklyReport();
      this.getRkpProduksiDaily(moment().format('MM'));
    },
    methods: {
      get(){
        let context = this;               
        Api(context, produksi.getCardAll({month: context.month, year: context.year})).onSuccess(function(response) {    
            context.Slt = response.data.data.Slt;
            context.Tll = response.data.data.Tll;
            context.Shr = response.data.data.Shr;

            context.totalWeightSltDhj = response.data.data.totalWeightSltDhj.totalWeightSltDhj;
            context.totalWeightSltKpi = response.data.data.totalWeightSltKpi.totalWeightSltKpi;
            context.totalWeightTllDhj = response.data.data.totalWeightTllDhj;
            context.totalWeightTllKpi = response.data.data.totalWeightTllKpi;

            context.tableAkumulasiClientSlitting.data = response.data.data.totalAkumulasiSlitting;
            context.totalAkumulasiSlittingAll         = +response.data.data.totalAkumulasiSlittingAll[0].weight_slitting + +response.data.data.totalAkumulasiSlittingAll[0].scrap_slitting;
            context.tableAkumulasiClientTolling.data  = response.data.data.totalAkumulasiTolling;
            context.totalAkumulasiTollingAll          = response.data.data.totalAkumulasiTollingAll;
        }).onError(function(error) {                    
            if (error.response.status == 404) {
            }
        }).onFinish(function() {  
            context.fillData()
        })
        .call()
      },
      getRkpProduksiMonth(param){
        let context = this;               
        Api(context, produksi.getRkpProduksiMonth({year: context.year})).onSuccess(function(response) {    
            context.rkpSlt = response.data.data.sltInt;
            context.rkpTll = response.data.data.tll;
            context.rkpShr = response.data.data.shr;
            
            context.totalWeightProdSlt = response.data.data.totalWeightProdSlt;
            context.totalWeightProdTll = response.data.data.totalWeightProdTll;
            context.totalWeightProdShr = response.data.data.totalWeightProdShr;
        }).onError(function(error) {                    
            if (error.response.status == 404) {
            }
        })
        .call()
      },
      getRkpProduksiDaily(month){
        let context = this;               
        Api(context, produksi.getRkpProduksiDaily({month: month, year: context.year})).onSuccess(function(response) {
            context.table.data    = response.data.data.slt;
            context.table.dataTll = response.data.data.tll;
            context.table.dataShr = response.data.data.shr;
            
            context.weightSltDaily = response.data.data.weightSltDaily;
            context.weightTllDaily = response.data.data.weightTllDaily;
            context.weightShrDaily = response.data.data.weightShrDaily;

            context.month = month;
            context.get(month)
            context.$forceUpdate();
        }).onError(function(error) {                    
            if (error.response.status == 404) {
            }
        })
        .call()
      },
      getWeeklyReport(month){
        let context = this;               
        Api(context, produksi.getWeeklyReport({month: month})).onSuccess(function(response) {    
            context.hrcStock  = response.data.data.hrcStock;
            context.scStock   = response.data.data.scStock;
            context.sipoStock  = response.data.data.sipoStock;
            context.poSlitting = response.data.data.poSlitting;
            context.poTolling  = response.data.data.poTolling;

            context.start           = response.data.data.start;
            context.end             = response.data.data.end;
            context.weeklySlt       = response.data.data.weeklySlt;
            context.weeklyAklmsiSlt = response.data.data.weeklyAklmsiSlt;
            context.weeklyTll       = response.data.data.weeklyTll;
            context.weeklyAklmsiTll = response.data.data.weeklyAklmsiTll;
            context.currentWeekSlt  = response.data.data.currentWeekSlt;
            context.currentWeekTll  = response.data.data.currentWeekTll;

            context.prodMonths = response.data.data.prodMonths;
            context.buildProdMonthsChart();
            context.buildStokChart();
            context.buildPoChart();

            console.log(response.data.data)
        }).onError(function(error) {
            if (error.response.status == 404) {
            }
        }).onFinish(function() {
            context.fillData()
        })
        .call()
      },
      buildProdMonthsChart () {
        this.prodMonthsChartData = {
          labels: this.prodMonths.map(function(pm) { return pm.label }),
          datasets: [
            {
              label: 'Slitting',
              backgroundColor: '#4c86d1',
              data: this.prodMonths.map(function(pm) { return Number(pm.slitting || 0) })
            },
            {
              label: 'Pipa',
              backgroundColor: '#5cb583',
              data: this.prodMonths.map(function(pm) { return Number(pm.pipa || 0) })
            }
          ]
        }
      },
      buildStokChart () {
        var palette = ['#4c86d1', '#5cb583', '#dba434', '#d5766f', '#8f7bc9', '#4fa3d1', '#67728c', '#f0ad4e', '#5bc0de', '#e2725b']
        this.hrcDoughnutData = {
          labels: this.hrcStock.map(function(row) { return row.owner }),
          datasets: [{
            backgroundColor: this.hrcStock.map(function(row, i) { return palette[i % palette.length] }),
            data: this.hrcStock.map(function(row) { return Number(row.sisa_ton || 0) })
          }]
        }
      },
      buildPoChart () {
        var self = this
        var owners = []
        this.poSlitting.concat(this.poTolling).forEach(function(row) {
          if (owners.indexOf(row.owner) === -1) owners.push(row.owner)
        })
        function findAkumulasi(arr, owner) {
          var match = arr.filter(function(row) { return row.owner === owner })[0]
          return match ? Number(match.akumulasi_ton || 0) : 0
        }
        this.poChartData = {
          labels: owners,
          datasets: [
            {
              label: 'PO Slitting',
              backgroundColor: '#5cb583',
              data: owners.map(function(o) { return findAkumulasi(self.poSlitting, o) })
            },
            {
              label: 'PO Tolling',
              backgroundColor: '#4fa3d1',
              data: owners.map(function(o) { return findAkumulasi(self.poTolling, o) })
            }
          ]
        }
      },
      onReportTabClick (event) {
        var self = this
        var target = event && event.target
        var link = target && target.closest ? target.closest('a.nav-link') : null
        var text = link ? link.textContent : (target ? target.textContent : '')
        this.$nextTick(function() {
          setTimeout(function() {
            if (text.indexOf('Stok Material') !== -1) self.hrcChartKey++
            if (text.indexOf('SIPO') !== -1) self.poChartKey++
            window.dispatchEvent(new Event('resize'))
          }, 100)
        })
      },
      toggleDiagram () {
        var self = this
        this.showDiagram = !this.showDiagram
        if (this.showDiagram) {
          this.$nextTick(function() {
            setTimeout(function() {
              self.diagramChartKey++
            }, 100)
          })
        }
      },
      fillData () {
        this.datacollection = {
          labels: ['SLITTING', 'TOLLING', 'SHEARING ALL CLIENT'],
          datasets: [
            {
              label: 'DHJ',
              backgroundColor: '#7FFFD4',
              data: [this.totalWeightSltDhj,this.totalWeightTllDhj,this.totalWeightShrAll]
            }, 
            {
              label: 'KPI',
              backgroundColor: '#f87979',
              data: [this.totalWeightSltKpi,this.totalWeightTllKpi,0]
            }
          ],
        }
      },
      convertRp(bilangan) {
        if (bilangan) {
          var number_string = bilangan.toString(),
              sisa    = number_string.length % 3,
              rupiah  = number_string.substr(0, sisa),
              ribuan  = number_string.substr(sisa).match(/\d{3}/g);

          if(ribuan){
            var separator = sisa ? '.' : '';
            rupiah += separator + ribuan.join('.');
            return rupiah
          }else{
            return bilangan
          }
        }
      },
      convertTon(bilangan, decimals) {
        var d = (decimals === undefined) ? 2 : decimals;
        return Number(bilangan || 0).toLocaleString('id-ID', {minimumFractionDigits: d, maximumFractionDigits: d});
      },
      sumStock(arr, key) {
        if (!arr || !arr.length) return 0;
        return arr.reduce(function(total, row) { return total + Number(row[key] || 0); }, 0);
      },
      
    }
  }
</script>
<style lang='scss' scoped>
  @import "@/assets/scss/light-bootstrap-dashboard.scss";

  /* ============ GENERAL REPORT TABLE POLISH (applies to every <table border='1'>) ============ */
  table[border='1'] {
    border-collapse: separate !important;
    border-spacing: 0;
    width: 100%;
    border: 1px solid #e7e9f0 !important;
    border-radius: 8px;
    overflow: hidden;
    font-family: inherit;
  }
  table[border='1'] th,
  table[border='1'] td {
    border: 1px solid #eef0f6 !important;
    padding: 9px 12px !important;
    vertical-align: middle;
  }
  table[border='1'] thead th {
    font-size: 11.5px !important;
    text-transform: uppercase;
    letter-spacing: .4px;
    color: #fff !important;
    font-weight: 600 !important;
    border-color: rgba(255,255,255,.25) !important;
    white-space: nowrap;
  }
  table[border='1'] tbody tr {
    transition: background-color .12s ease-in-out;
  }
  table[border='1'] tbody tr:nth-child(even) {
    background-color: #f8f9fc;
  }
  table[border='1'] tbody tr:hover {
    background-color: #eef2fb;
  }

  /* ============ SECTION TITLES ============ */
  .section-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14.5px !important;
    color: #344675;
    letter-spacing: .2px;
    margin: 26px 0 10px 0 !important;
    padding-bottom: 8px;
    border-bottom: 2px solid #eef0f6;
  }
  .section-title:first-of-type { margin-top: 6px !important; }
  .section-title .section-dot {
    width: 9px;
    height: 9px;
    border-radius: 50%;
    display: inline-block;
    flex-shrink: 0;
  }
  .section-title i {
    font-size: 15px;
    color: #a9a9c1;
  }

  /* ============ THEMED TABLE HEADERS (each table keeps its own color, so it's easy to tell tables apart at a glance) ============ */
  .thead-slate th   { background-color: #67728c !important; }
  .thead-blue th    { background-color: #4c86d1 !important; }
  .thead-amber th   { background-color: #dba434 !important; }
  .thead-rose th    { background-color: #d5766f !important; }
  .thead-violet th  { background-color: #8f7bc9 !important; }
  .thead-green th   { background-color: #5cb583 !important; }
  .thead-sky th     { background-color: #4fa3d1 !important; }

  .dot-slate  { background-color: #67728c; }
  .dot-blue   { background-color: #4c86d1; }
  .dot-amber  { background-color: #dba434; }
  .dot-rose   { background-color: #d5766f; }
  .dot-violet { background-color: #8f7bc9; }
  .dot-green  { background-color: #5cb583; }
  .dot-sky    { background-color: #4fa3d1; }

  /* ============ TOTAL / HIGHLIGHT ROWS ============ */
  .row-highlight td {
    background-color: #eef1f8 !important;
    border-top: 2px solid #344675 !important;
    border-bottom: 2px solid #344675 !important;
    font-weight: 700 !important;
  }
  table[border='1'] tbody tr:last-child td {
    font-weight: 600;
  }

  /* ============ CARD HEADER TITLES (other cards on this page) ============ */
  .card-title.font-weight-bold {
    letter-spacing: .2px;
  }
  .card-title.font-weight-bold i {
    color: #9dabc7;
  }
  .card-subtitle-muted {
    font-size: 12px !important;
    font-weight: 500 !important;
    color: #9a9a9a !important;
    letter-spacing: .3px;
  }
  .mr-2 { margin-right: 8px; }

  /* Breathing room between the report cards on this page */
  .content ::v-deep .card {
    margin-bottom: 28px;
  }

  /* ============ REPORT TABS (Produksi / Stok Material / SIPO & PO) ============ */
  .report-tabs ::v-deep .nav-wrapper {
    margin-bottom: 18px;
  }
  .report-tabs ::v-deep .nav-pills .nav-link {
    font-size: 13px;
    font-weight: 600;
    letter-spacing: .2px;
    color: #67728c;
    border-radius: 30px;
    padding: 8px 18px;
  }
  .report-tabs ::v-deep .nav-pills .nav-link.active {
    background-color: #344675;
    color: #fff;
    box-shadow: 0 4px 10px rgba(52,70,117,.25);
  }
  .report-tabs ::v-deep .tab-content .section-title:first-of-type {
    margin-top: 0 !important;
  }

  /* ============ CHART BOX ============ */
  .chart-box {
    background: #fff;
    border: 1px solid #eef0f6;
    border-radius: 10px;
    padding: 16px 18px 6px 18px;
    box-shadow: 0 2px 8px rgba(52,70,117,.05);
  }
  .chart-box-title {
    font-size: 12.5px;
    font-weight: 600;
    color: #67728c;
    text-align: center;
    letter-spacing: .2px;
    margin-bottom: 8px;
  }

  /* ============ COLLAPSE TOGGLE ============ */
  .btn-collapse-toggle {
    background: #f4f5f9;
    border: 1px solid #e7e9f0;
    color: #67728c;
    font-size: 12px;
    font-weight: 600;
    border-radius: 20px;
    padding: 6px 14px;
    cursor: pointer;
    transition: background-color .12s ease-in-out;
  }
  .btn-collapse-toggle:hover {
    background: #eef0f6;
  }
  .btn-collapse-toggle i {
    margin-right: 4px;
  }
</style>
